import { render, staticRenderFns } from "./destinationRegion.vue?vue&type=template&id=952f4856&scoped=true&"
import script from "./destinationRegion.vue?vue&type=script&lang=js&"
export * from "./destinationRegion.vue?vue&type=script&lang=js&"
import style0 from "./destinationRegion.vue?vue&type=style&index=0&id=952f4856&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952f4856",
  null
  
)

export default component.exports